<div class="loading-screen" *ngIf="showSplash">
  <p class="loading-pipette"><img src="{{ deployUrl }}assets/images/pink-pipette.png"></p>
  <p class="loading-logo"><img src="{{ deployUrl }}assets/images/skinpro_logo.svg"></p>
  <p class="loading-brand"><img src="{{ deployUrl }}assets/images/ascp_logo.png"></p>
</div>